

export const defaultErrorToast = () => {
  alert('Un problème est survenu')
}
